export const selector = 'dbMailTo';
const subjectSelector = 'dbMailSubject';
const bodySelector = 'dbMailBody';

function buildGetter($parse, attrs, name) {
    if (!attrs[name]) {
        return () => null;
    }

    try {
        return $parse(attrs[name]);
    } catch (error) {
        return () => attrs[name];
    }
}

/* @ngInject */
export default function MailToDirective($parse) {
    return {
        restrict: 'A',
        
        link: (scope, element, attrs) => {
            const emailGetter = buildGetter($parse, attrs, selector);
            const subjectGetter = buildGetter($parse, attrs, subjectSelector);
            const bodyGetter = buildGetter($parse, attrs, bodySelector);

            scope.$watchGroup([
                () => emailGetter(scope),
                () => subjectGetter(scope),
                () => bodyGetter(scope)
            ], ([email, subject, body]) => {
                if (!email) {
                    attrs.$set('href', null);
                    return;
                }

                const query = [];

                if (subject) {
                    query.push(`subject=${encodeURIComponent(subject)}`);
                }

                if (body) {
                    query.push(`body=${encodeURIComponent(body)}`);
                }

                const href = `mailto:${email}${query.length ? `?${query.join('&')}` : ''}`;

                attrs.$set('href', href);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/common/directive/mail-to/mail-to.directive.js